import { ReactNode } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import cn from 'classnames'

type Theme = 'white' | 'small'

type Props = {
  children?: ReactNode
  theme?: Theme
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '20px 0',
    bottom: 0,
    borderTop: '2px solid #e6e6e6',
    position: 'relative',
    lineHeight: '20px',
    color: '#757575',
    '& p': {
      fontSize: '90%',
      fontWeight: 300,
      margin: '0 25px',
    },
  },
  white: {
    height: 60,
    background: '#fff',
  },
  small: {
    height: 'auto',
    width: 'auto',
    padding: 0,
    backgroundColor: '#F5F8FA',
    border: 'none',
    position: 'static',
  },
})

const SimpleCopyrightFooter = ({ children, theme = 'white' }: Props) => {
  const classes = useStyles()
  const currentYear = new Date().getFullYear()
  return (
    <div className={cn(classes.root, classes[theme])}>
      <p>
        &copy; {currentYear} SCOIR Inc. All Rights Reserved. {children}
      </p>
    </div>
  )
}

export default SimpleCopyrightFooter
